export const TERMS_LINK = 'https://blooksy.com/terms-of-service';
export const PRIVACY_LINK = 'https://blooksy.com/privacy-policy';
